import { useQueryParams } from '@main/core-ui';
import { PAGES_WITHOUT_TAKE_CONTROL } from '@main/pc-types';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

import {
  selectPrivacyCenterPages,
  selectRequiredPrivacyCenter,
} from '../containers/App/selectors';
import NotFound from '../containers/NotFound';

/**
 * Redirect to the first enabled page
 */
export const HomePage: React.FC<React.PropsWithChildren<unknown>> = () => {
  const location = useLocation();
  const { locale } = useIntl();

  const { locales } = useSelector(selectRequiredPrivacyCenter);
  const { modal } = useQueryParams();
  const links = useSelector(selectPrivacyCenterPages);
  // Skip passing query string for certain pages when
  // the modal is set to take control
  const skipPassingQueryParams = useMemo(
    () =>
      PAGES_WITHOUT_TAKE_CONTROL.some(
        (page) => links[0] && links[0].href.includes(page),
      ) && modal === 'take-control',
    [links, modal],
  );
  const firstLink = links[0];
  // nothing is enabled - misconfiguration
  if (!firstLink) {
    return <NotFound />;
  }

  return (
    <Navigate
      to={{
        ...location,
        search: skipPassingQueryParams ? '' : location.search,
        pathname:
          locales.length > 1 ? `${firstLink.href}/${locale}/` : firstLink.href,
      }}
      replace
    />
  );
};
